export default __webpack_public_path__ + "static/media/CourtneyBono.bc9ce20f.jpg";